export default "__VITE_ASSET__B9VdSm0y__"